import { DataQuery, DataQueryProps } from "~/components/DataQueries/DataQuery";

const FrameworkControlDataQueryEntryPage = ({ space }: DataQueryProps) => {
  return <DataQuery {...{ space }} />;
};

export default FrameworkControlDataQueryEntryPage;
